import { createSlice } from '@reduxjs/toolkit'

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  predic_start_time: null,
  predic_end_time: null,
  admin_commission: 20,
  slots_per_user: 100000,
  option:[{ id: 1, option: "YES", isCorrect: false }, { id: 2, option: "NO", isCorrect: false }],
  interval:1
};

export const categorySlice = createSlice({
  name: 'categorySlice',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isEdit:false,
    isAdd:false,
  },
  reducers: {
    stateRefresh: (state, action) => {
      state.questionStates = initialQuestionState
      state.isEdit =false
      state.isAdd=true
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
      state.isEdit=action.payload.isEdit
    },
    setStatus: (state, action) => {
      state.questionStates.status = action.payload.status
    },
    setAmountState:(state,action) =>{
      state.questionStates.rate_id1 =  action.payload.value
      state.questionStates.rate_id2 = 10 - Number(action.payload.value)
    }
  }
})

// Action creators are generated for each case reducer function
export const { addQuestion, stateRefresh, stateValues, setEditQuestion,setStatus,setAmountState } = categorySlice.actions

export default categorySlice.reducer